export enum PaymentResponseType
{
    Success = 1,
    InvalidCpr = 2,
    PlayerExists = 3,
    DibsAuthorizationFailed = 4,
    OrderExpired = 5,
    UnknownError = 6
}
